import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TctWebIcon from "assets/customIcons/navigation/TctWebIcon";
import ButtonDefault from "components/DesignComponents/ButtonDefault";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import AuthContext from "context/auth/authContext";
import RoutesContext from "context/routes/routesContext";
import { isInternalOrPremiumLevel, usePermissions } from "shared";

import TctWebDialog from "./TctWebDialog";

const TctWeb = () => {
    const { gray100, gray200, gray700, textDisabled } = colors;

    const { user } = useContext(AuthContext);

    const { isDesktopDrawerOpen, isMobileDrawerOpen } =
        useContext(RoutesContext);

    const { t } = useTranslation();

    const {
        isEditInTctWebNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const openDialog = () => setIsDialogOpen(true);
    const closeDialog = () => setIsDialogOpen(false);

    const isBasicOrStandard = !isInternalOrPremiumLevel(user?.company_level);
    const isDisabled = isEditInTctWebNotAllowed || isBasicOrStandard;

    const getTooltipTitle = () => {
        if (isEditInTctWebNotAllowed) {
            return getNoPermissionTooltipTitle(PERMISSIONS.FileTctWebAccess);
        }

        if (isBasicOrStandard) {
            return t("Tct##tct web disabled description");
        }

        if (!isDesktopDrawerOpen && !isMobileDrawerOpen) {
            return t("Tct##tct web");
        }

        return undefined;
    };

    return (
        <>
            <li>
                <TooltipGeneral
                    title={getTooltipTitle()}
                    placement={TOOLTIP_PLACEMENT.Right}
                    disableTouchListener
                >
                    <div>
                        <ButtonDefault
                            className="navigation-item"
                            onClick={openDialog}
                            css={css({
                                color: isDisabled ? textDisabled : gray700,
                                pointerEvents: isDisabled ? "none" : "auto",
                                cursor: "pointer",
                                width: "stretch",
                                padding: "6px",

                                "& > span": {
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    lineHeight: "20px",
                                    letterSpacing: "0.1px",
                                    marginLeft: "8px",
                                    whiteSpace: "nowrap"
                                },

                                "&:hover": {
                                    backgroundColor: gray100
                                },

                                "&:active": {
                                    backgroundColor: gray200
                                }
                            })}
                        >
                            <TctWebIcon />
                            <span>{t("Tct##tct web")}</span>
                        </ButtonDefault>
                    </div>
                </TooltipGeneral>
            </li>

            <TctWebDialog isOpen={isDialogOpen} close={closeDialog} />
        </>
    );
};

export default TctWeb;
